<template>
  <v-card :loading="loading">
    <v-card-title class="headline">
      Вы действительно хотите дослать письмо?
    </v-card-title>

    <v-card-text>
      В случае досыла, письмо нужно будет посадить в пост-пакет заново
    </v-card-text>

    <template>
      <v-container>
        <v-row align="center">
          <v-col
              class="d-flex"
              cols="12"
              sm="12"
          >
            <v-autocomplete v-model="region"
                            :items="$store.getters.appLogin.regions"
                            :item-value="item => item"
                            :item-text="item => item.name"
                            :clearable="true"
                            label="Область"
            />
          </v-col>
          <v-col
              class="d-flex"
              cols="12"
              sm="12"
          >
            <v-autocomplete v-model="area"
                            :items="regionAreas"
                            :item-value="item => item"
                            :item-text="item => item.name"
                            :clearable="true"
                            label="Район"
            />
          </v-col>
          <v-col
              class="d-flex"
              cols="12"
              sm="12"
          >
            <v-autocomplete v-model="postIndex"
                            :items="areaPostIndexes"
                            :item-value="item => item"
                            :item-text="item => item.name"
                            :clearable="true"
                            label="Пост индекс"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>

    <v-card-actions>
      <v-btn color="default" text @click="onCloseClicked" :disabled="loading">Закрыть</v-btn>
      <v-spacer/>
      <v-btn color="error" text dark @click="onUnsetClicked" :disabled="loading">Да, дослать</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isUnsetFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить досыл
    </v-snackbar>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import MailService from "@/services/mail.service";
import {APP_MAIL_UNSET_POST_PACKAGE} from "@/store/modules/app/actions";
import _ from "underscore";

export default {
  name: "MailUnsetPostPackage",
  props: {
    mail: {
      type: Object,
      default: null
    }
  },
  computed: {
    allowSelectRegions() {
      return this.$store.getters.appIsAdminLogin
          || this.$store.getters.appIsPostOfficeRegionLogin
    },
    allowSelectAreas() {
      return this.$store.getters.appIsAdminLogin
          || this.$store.getters.appIsPostOfficeRegionLogin
          || this.$store.getters.appIsPostOfficeAreaOperator
    },
    allowSelectPostIndexes() {
      return this.$store.getters.appIsAdminLogin
          || this.$store.getters.appIsPostOfficeRegionLogin
          || this.$store.getters.appIsPostOfficeAreaOperator
          || this.$store.getters.appIsOperatorLogin
    },
    regionAreas() {
      let vm = this;
      let regionAreas = _.filter(vm.$store.getters.appLogin.areas, function(area) {
        return area.region.id === vm.region.id
      })

      vm.area = regionAreas[0]
      return regionAreas
    },
    areaPostIndexes() {
      let vm = this;
      let areaPostIndexes = _.filter(vm.$store.getters.appPostIndexes, function (postIndex) {
        return postIndex.postDistrictCode === vm.area.id
      })

      vm.postIndex = areaPostIndexes[0]
      return areaPostIndexes
    }
  },
  data() {
    return {
      loading: false,
      isUnsetFailed: false,

      region: this.mail.region,
      area: this.mail.area,
      postIndex: this.mail.postIndex
    }
  },
  methods: {
    isAdmin() {
      return this.$store.getters.appIsAdminLogin
    },
    onCloseClicked() {
      this.$emit('close')
    },
    onUnsetClicked() {
      this.loading = true
      this.$store.dispatch(LAYOUT_LOADING_START)

      let regionId = this.region != null ? this.region.id : null;
      let areaId = this.area != null ? this.area.id : null;
      let postIndexId = this.postIndex != null ? this.postIndex.id : null

      MailService.unsetPostPackage(this.mail.uid, regionId, areaId, postIndexId)
          .then(() => {
            this.$store.dispatch(APP_MAIL_UNSET_POST_PACKAGE, {mail: this.mail})
          })
          .catch(() => {
            this.isUnsetFailed = true
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          });
    }
  }
}
</script>

<style scoped>

</style>